import { __awaiter, __generator } from "tslib";
import { Command } from './client-msg.interface';
import { ClientProxy } from './client-proxy';
import { NativeEngineTable } from './table';
import { getCollectionSchema } from './utils/common';
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["ACTIVE"] = "active";
    TransactionStatus["COMMITTING"] = "committing";
    TransactionStatus["COMPLETED"] = "completed";
})(TransactionStatus || (TransactionStatus = {}));
var NativeEngineTransaction = /** @class */ (function () {
    function NativeEngineTransaction(tables, dbName, dbSchema, transactionID, mode, engineAspects) {
        var _this = this;
        this.tables = tables;
        this.dbName = dbName;
        this.dbSchema = dbSchema;
        this.transactionID = transactionID;
        this.mode = mode;
        this.engineAspects = engineAspects;
        this.reqSeqFactory = (function () {
            var seq = 0;
            return function () { return (seq += 1); };
        })();
        this.dbRequestSeqAndResponseMap = new Map();
        this.transactionStatus = "active" /* ACTIVE */;
        this.autoCommitTimerId = null;
        this.onTransactionDonePromiseResolve = function () { };
        this.onTransactionDonePromiseReject = function () { };
        this.waitingTransactionDonePromise = new Promise(function (resolve, reject) {
            _this.onTransactionDonePromiseResolve = resolve;
            _this.onTransactionDonePromiseReject = reject;
        });
        if (engineAspects === null || engineAspects === void 0 ? void 0 : engineAspects.transaction) {
            this.applyAspectPatch();
        }
        this.tryToAutoCommit();
    }
    NativeEngineTransaction.prototype.notifyTransactionFail = function (error) {
        this.onTransactionDonePromiseReject(error);
        this.clearAutoCommitTimer();
    };
    /**
     * return a promise which state change by transaction lifecycle
     */
    NativeEngineTransaction.prototype.waitForTransactionDone = function () {
        return this.waitingTransactionDonePromise;
    };
    /**
     * record request happen in this transaction
     * @param respPromise request response promise
     */
    NativeEngineTransaction.prototype.addResponsePromise = function (respPromise) {
        var _this = this;
        var seq = this.reqSeqFactory();
        this.clearAutoCommitTimer();
        this.dbRequestSeqAndResponseMap.set(seq, respPromise);
        respPromise.then(function () {
            _this.dbRequestSeqAndResponseMap.delete(seq);
            _this.tryToAutoCommit();
        });
    };
    NativeEngineTransaction.prototype.table = function (tableName) {
        return new NativeEngineTable(this.dbName, getCollectionSchema(tableName, this.dbSchema), this.mode, this.engineAspects, this);
    };
    NativeEngineTransaction.prototype.commit = function (triggerByAutoCommit) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var req, resp;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        // clear auto commit timer
                        this.clearAutoCommitTimer();
                        if (this.transactionStatus !== "active" /* ACTIVE */) {
                            if (!triggerByAutoCommit) {
                                // TODO('linelin') 临时逻辑添加主动上报
                                (_b = (_a = window.log) === null || _a === void 0 ? void 0 : _a.report) === null || _b === void 0 ? void 0 : _b.call(_a, 'transaction_repeat_error', {
                                    query: {
                                        sessionId: (_d = (_c = window.log) === null || _c === void 0 ? void 0 : _c.var) === null || _d === void 0 ? void 0 : _d.sessionId,
                                    },
                                });
                            }
                            return [2 /*return*/, true];
                        }
                        // transaction id is undefined when it native db is not support transaction
                        if (!this.transactionID) {
                            this.onTransactionDonePromiseResolve();
                            return [2 /*return*/, true];
                        }
                        req = {
                            command: Command.COMMIT_TRANSACTION,
                            dbName: this.dbName,
                            transaction: this.transactionID,
                        };
                        this.transactionStatus = "committing" /* COMMITTING */;
                        return [4 /*yield*/, ClientProxy.send(req)];
                    case 1:
                        resp = _e.sent();
                        this.transactionStatus = "completed" /* COMPLETED */;
                        if (resp.err_code || resp.err_msg) {
                            this.onTransactionDonePromiseReject();
                            return [2 /*return*/, false];
                        }
                        this.onTransactionDonePromiseResolve();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    NativeEngineTransaction.prototype.rollback = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // transaction id is undefined when it native db is not support transaction
                        if (!this.transactionID) {
                            this.onTransactionDonePromiseResolve();
                            return [2 /*return*/, true];
                        }
                        req = {
                            command: Command.ROLLBACK_TRANSACTION,
                            dbName: this.dbName,
                            transaction: this.transactionID,
                        };
                        return [4 /*yield*/, ClientProxy.send(req)];
                    case 1:
                        resp = _a.sent();
                        if (resp.err_code || resp.err_msg) {
                            this.onTransactionDonePromiseReject();
                            return [2 /*return*/, false];
                        }
                        this.onTransactionDonePromiseResolve();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * bind the hook stub to the transaction object
     */
    NativeEngineTransaction.prototype.applyAspectPatch = function () {
        var _a;
        var transactionAspects = (_a = this.engineAspects) === null || _a === void 0 ? void 0 : _a.transaction;
        var hookTarget = this;
        transactionAspects === null || transactionAspects === void 0 ? void 0 : transactionAspects.commit.patch(hookTarget, 'commit');
        transactionAspects === null || transactionAspects === void 0 ? void 0 : transactionAspects.rollback.patch(hookTarget, 'rollback');
        transactionAspects === null || transactionAspects === void 0 ? void 0 : transactionAspects.table.patch(hookTarget, 'table');
    };
    NativeEngineTransaction.prototype.tryToAutoCommit = function () {
        var _this = this;
        if (this.dbRequestSeqAndResponseMap.size === 0 && this.autoCommitTimerId === null) {
            this.autoCommitTimerId = setTimeout(function () {
                if (_this.dbRequestSeqAndResponseMap.size === 0 && _this.transactionStatus === "active" /* ACTIVE */) {
                    _this.commit(true);
                }
            });
        }
    };
    NativeEngineTransaction.prototype.clearAutoCommitTimer = function () {
        if (this.autoCommitTimerId !== null) {
            clearTimeout(this.autoCommitTimerId);
            this.autoCommitTimerId = null;
        }
    };
    return NativeEngineTransaction;
}());
export { NativeEngineTransaction };
//# sourceMappingURL=transaction.js.map